import { localStorageUtil } from '../../utils/local-storage.util';

export interface TemporaryScenarioStakeholdersValue {
  [scenarioId: string]: string[];
}

export const temporaryScenarioStakeholdersStore =
  localStorageUtil<TemporaryScenarioStakeholdersValue>('temporary_stakeholders');
